import { render } from "./AbtestMessageConfirmPage.vue?vue&type=template&id=2b842264"
import script from "./AbtestMessageConfirmPage.vue?vue&type=script&lang=js"
export * from "./AbtestMessageConfirmPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__